module.exports = new __parcel__URL__("insights-new-layout.tpl.4a3fb44d.svg").toString();